import { ISortByOption } from '../common/view-model';
export const filterSortOptionsById = (sortOptions: ISortByOption[], requiereIds: string[]) => {
	return [...sortOptions.filter((option: ISortByOption) => requiereIds.includes(option.id))];
};
